<template>
    <div ref="main" class="fix-page">
        <div class="main" style="background-color: #f5f5f5;min-height: 100vh">
            <video v-if="poster.video" class="video" :src="fileUrl+poster.video" controls="controls"
                   style="width: 100%;height: 100%;">
            </video>
            <div style="height: 20px"></div>
            <div v-for="(item,index) in poster.posterItems" :key="index" style="position: relative">
                <div class="step">{{ item.number }}</div>
                <div class="card" v-if="item.image">
                    <img :src="fileUrl+item.image" alt="" @click="goPage(item.url)">
                    <h3 v-if="item.title" class="card-title">{{ item.title }}</h3>
                    <div v-if="item.content" class="card-content">{{ item.content }}</div>
                    <div v-if="item.content" class="card-copy" @click="copyContent(item)">点击复制</div>
                </div>
                <!--            @click="goPage(item.url)"-->
                <div class="card" v-else>
                    <img :src="fileUrl+config['默认图片']" alt="" @click="goPage(item.url)">
                    <h3 v-if="item.title" class="card-title">{{ item.title }}</h3>
                    <div v-if="item.content" class="card-content">{{ item.content }}</div>
                    <div v-if="item.content" class="card-copy" @click="copyContent(item)">点击复制</div>
                </div>
            </div>
            <div style="height: 200px"></div>
            <div v-if="showTip" class="reminder-box">
                {{ tipText }}
            </div>
            <div
                v-if="showHelp"
                style="color: #f00;font-size: 0.6rem;padding-top:0.5rem;height: 100vh;width: 100vw;position: fixed;z-index: 999;top: 0;background-color: #000c">
                <div>1. 点击右上角三个点</div>
                <img :src="fileUrl+'2025/05/17/196de9e0f8d1a.png'" style="width: 50vw">
                <div> 2. 点击在浏览器打开</div>
                <img :src="fileUrl+'2025/05/17/196dea11d3313.png'" style="width: 50vw">
                <div> 3. 选择系统浏览器(华为浏览器/小米浏览器等等)</div>
                <img :src="fileUrl+'2025/05/17/196de9dfe4318.png'" style="width: 50vw">
            </div>
        </div>
        <div class="go-top-logo" v-show="showGoTop" @click="goTop">
        </div>
    </div>
</template>

<style>


</style>
<script>
import {fileUrl} from "@/utils/global";
import LightReminder from "@/components/LightReminder.vue";

export default {
    name: "HomeView",
    components: {LightReminder},
    data() {
        return {
            tipText: 'xxx',
            fileUrl: fileUrl,
            showTip: false,
            showHelp: false,
            config: {
                '默认图片': ''
            },
            showGoTop: false,
            poster: {
                id: null,
                url: '',
                title: '',
                video: '',
                content: '',
                background: '',
                notes: '',
                posterItems: []
            },
            lastPos: 0,
            timer: null,
            code: '404'
        }
    },
    created() {
        //获取code参数
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        this.code = code;
        this.$ajax.post("/api/poster/find/" + code, null).then((res) => {
            if (res.data.code !== 200) {
                return
            }
            this.poster = res.data.data;
            document.title = this.poster.title;
        });
        this.$ajax.post("/api/config/findAll", null).then((res) => {
            let list = res.data.data;
            for (let i = 0; i < list.length; i++) {
                this.config[list[i].configKey] = list[i].value;
            }
        });

    },
    mounted() {
        this.detectBrowser();
        this.createScrollTimer();
        this.goLastPos()
    },
    methods: {
        createScrollTimer() {
            let that = this;
            this.timer = setInterval(() => {
                try {
                    let y = that.$refs.main.scrollTop;
                    let now = Math.floor(new Date().getTime() / 1000);
                    let code = that.code;
                    if (that.lastPos - y > 100) {
                        that.showGoTop = true;
                    }
                    if (y - that.lastPos > 100) {
                        that.showGoTop = false;
                    }
                    that.lastPos = that.$refs.main.scrollTop;
                    //保存到本地
                    localStorage.setItem('scroll_pos_' + code, JSON.stringify({date: now, y: y}));
                } catch (e) {

                }// console.log(now)
                // window.scrollBy(0, 10);
                // this.goScroll(this.$refs.main.scrollTop + 10);
            }, 500);
        },
        goTop() {
            this.$refs.main.scrollTop = 0;
        },
        goLastPos() {
            try {
                let data = JSON.parse(localStorage.getItem('scroll_pos_' + this.code));
                if (data == null || data.date == null || data.y == null) {
                    return;
                }
                let now = Math.floor(new Date().getTime() / 1000);
                let clearTime = 60 * 20;
                if (now - data.date > clearTime) {
                    return;
                }
                setTimeout(() => {
                    this.$refs.main.scrollTop = data.y;
                    this.showGoTop = false;
                    this.lastPos = data.y;
                }, 200)
            } catch (e) {

            }
        },
        getImagePath(name) {
            return require(`@/assets/${name}.png`);
        },
        //获取当前时间 格式为 yyyy-MM-dd HH:mm:ss
        getNowDate() {
            let date = new Date();
            return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        },
        copyContent(item) {
            if (item.content) {
                let input = document.createElement('input');
                input.value = item.content;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);

                this.tipText = '复制成功, 请在小红书粘贴';
                this.showTip = true;

                setTimeout(() => {
                    this.showTip = false;
                }, 2000);
            }
        },
        goPage(url) {
            if (url === '') {
                return;
            }
            window.location.href = url;
        },
        detectBrowser() {
            const ua = navigator.userAgent.toLowerCase();
            const isAndroid = ua.indexOf('android') > -1;
            const isWeChat = ua.indexOf('micromessenger') > -1;

            if (isAndroid && isWeChat) {
                this.showHelp = true;
            }
        }
    }
}
</script>


<style scoped>
.tip {
    position: fixed;
    bottom: 30vh;
    background-color: #f3f3f3;
    left: 0;
    margin: auto;
}

.card-copy {
    text-align: center;
    font-size: 16px;
    margin-top: 2px;
    color: #00bbf0
}

.card-title {
    font-size: 14px;
    text-align: center;
}

.card-content {
    font-size: 12px;
    text-align: left;
    text-indent: 2em;
    white-space: pre-wrap;
}

.card img {
    width: 60%;
    height: auto;
    border-radius: 10px;
}

.card {
    margin: 20px;
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.reminder-box {
    position: fixed;
    bottom: 30vh;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 1000;
    font-size: 12px;
}

.step {
    width: 24px;
    height: 24px;
    background-color: #FF6B00;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -12px;
    left: 12px;
    font-size: 14px;
}

.fix-page {
    position: relative;
    height: 100vh;
    overflow-y: scroll;
}

.go-top-logo {
    position: fixed;
    bottom: 10vw;
    right: 7vw;
    width: 10vw;
    height: 10vw;
    background-image: url('~@/assets/go_top.png');
    background-size: cover;
}

</style>
